<template>
    <div class="content">
        <div class="my-title">
            <Row :gutter="10">
                <Col span="18">我的保单</Col>
                <Col span="6">
                    <Select v-model="params.bizId" @on-change="getList">
                        <Option value="JIANGONG_EMPLOYER_LIABILITY">建工雇主</Option>
                        <Option value="JIANGONG_DEPOSIT">建工投标保证金 </Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <Tabs v-model="status">
            <TabPane label="全部" name=" "></TabPane>
            <TabPane label="待生效" name="TO_BE_EFFECTIVE"></TabPane>
            <TabPane label="保障中" name="EFFECTIVE"></TabPane>
            <TabPane label="已失效" name="EXPIRED"></TabPane>
        </Tabs>
        <div class="orders">
            <i-table :columns="columns" url="/broker/insurance/policy/list.json" :params="params" ref="table">
                <template slot-scope="{ row,index }" slot="action">
                    <!-- <Button type="primary" size="small" style="margin-right: 5px" @click="show(index)">View</Button> -->
                    <!-- <Button type="error" size="small" @click="remove(index)">Delete</Button> -->
                    <TableActionButton>
                        <a v-if="row.effectiveStatus!='EXPIRED'&&row.productCode!='JIANGONG_DEPOSIT'" @click="toDetail(row)">批单</a>
                        <a @click="toDetail(row,true)">查看</a>
                        <a @click="toDownlod(row)">下载电子保单</a>
                    </TableActionButton>
                </template>
            </i-table>
        </div>
    </div>
</template>
<script>
    import PolicyItem from '../common/PolicyItem'
    import ITable from '@/components/common/ITable'
    import TableActionButton from '../../common/TableActionButton'
    import { getAgentUrl } from '@/common/agent'
    import { mapState } from 'vuex'
    export default {
        components: { PolicyItem, ITable, TableActionButton },
        data () {
            return {
                loading: false,
                getAgentUrl: getAgentUrl,
                params: {
                    bizId: 'JIANGONG_EMPLOYER_LIABILITY',
                },
                status: ' ',
                columns: [
                    { title: '保单号', key: 'cntrNo' },
                    { title: '险种', key: 'productName', width: 240 },
                    // {title:'节点名称',key:''},
                    { title: '提交日期', key: 'createTime', width: 180, },
                    {
                        title: '操作',
                        slot: 'action',
                        width: 160,
                        align: 'center'
                    }
                ],
                list: {}
            }
        },
        watch: {
            status (v) {
                this.params.effectiveStatus = v
                this.$refs.table.getList()
            },
            userInfo (v) {
                this.checkLogin()
            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.common.info
            }),
        },
        created () {
            this.checkLogin()
        },
        methods: {
            getList(){
                this.$refs.table.getList()
            },
            // 下载电子保单
            toDownlod(row){
                if(!row.electronicPolicyUrl){
                    this.$Message.error('保司暂未生成电子保单!')
                } else {
                    window.open(row.electronicPolicyUrl)
                }
            },
            // 检测登录
            checkLogin () {
                if (!this.userInfo.userId) {
                    if (location.href && location.href.indexOf('/common.html#/login') == -1) {
                        window.location = location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(location.href);
                    }
                    return false
                } else {
                    return true
                }
            },
            async toDetail (data, flag) {
                if (flag) {
                    let url = '/haierProduct.html#/my/taskDetail/' + data.insuranceApplicationId + '?insurancePolicyId=' + data.insurancePolicyId + '&formPolicy=1'
                    // url= url+'?insurancePolicyId='+data.insurancePolicyId+'&insuranceApplicationId='+data.insuranceApplicationId
                    window.open(url)
                } else {
                    let url = '/agent.html#/agent/review'
                    url = url + '?insurancePolicyId=' + data.insurancePolicyId + '&insuranceApplicationId=' + data.insuranceApplicationId + '&formCustomized=1'
                    window.open(url)
                }
            },
        }
    }
</script>
<style scoped>
    .content {
        padding: 0 15px 15px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customized/policy.vue